import { useEffect, useState } from 'react';
import { MAX_PHOTOS, SchoolCard } from './SchoolCard';
import { SchoolSuggestion } from '../../search/types/typeaheadSuggestions';
import { SchoolDetails } from '../types/SchoolDetails';

export type SchoolSuggestionList = SchoolSuggestion[] | 'LOADING';
type SchoolDetailsList = SchoolDetails[] | 'LOADING';

const findSchool = function (schoolId: number, schoolDetailsList: SchoolDetailsList) {
    if (schoolDetailsList === 'LOADING') {
        return 'LOADING';
    }
    if (schoolDetailsList) {
        return schoolDetailsList.find(details => details.id === schoolId);
    }
    return null;
};

export const SchoolCardList = function SchoolCardList({ schools, maxCards = 3 }:
    {
        schools: SchoolSuggestionList,
        maxCards?: number,
    }) {
    const [schoolDetailsList, setSchoolDetailsList] = useState<SchoolDetailsList>([]);

    useEffect(() => {
        if (schools !== 'LOADING' && schools.length) {
            getSchoolDetails(schools);
        }
    }, [schools]);

    const getSchoolDetails = function (schools: SchoolSuggestion[]) {
        const schoolIds = schools.map((school) => school.schoolId).join(',');
        setSchoolDetailsList('LOADING');
        $.ajax({
            type: 'GET',
            url: `/school/school_details.html?schoolIds=${schoolIds}&maxPhotos=${MAX_PHOTOS}&fields=NUM_POSTED_PROJECTS,NUM_ELIGIBLE_TEACHERS_WITH_PROJECTS,TEACHER_PHOTOS`,
            cache: true,
            dataType: 'json',
        }).done(({ schools: schoolDetails }: { schools: SchoolDetails[] }) => {
            setSchoolDetailsList(schoolDetails);
        }).fail(() => {
            setSchoolDetailsList([]);
        });
    };

    const renderSchoolList = function () {
        if (schools !== 'LOADING') {
            return schools.slice(0, maxCards).map((school, index) =>
                <SchoolCard
                    school={school}
                    schoolDetails={findSchool(school.schoolId, schoolDetailsList)}
                    key={school.schoolId}
                />,
            );
        }

        const placeholderCards = [];
        for (let i = 0; i < maxCards; i++) {
            placeholderCards.push(<SchoolCard school='LOADING' key={-i} />);
        }
        return placeholderCards;
    };

    return (
        <div className="school-card-list">
            { renderSchoolList() }
        </div>
    );
};
